var map = {
	"./add_col_after.svg": 63504,
	"./add_col_before.svg": 49775,
	"./add_row_after.svg": 55010,
	"./add_row_before.svg": 49893,
	"./align-center.svg": 73140,
	"./align-left.svg": 33056,
	"./align-right.svg": 54895,
	"./bold.svg": 98662,
	"./checklist.svg": 28201,
	"./code.svg": 54600,
	"./combine_cells.svg": 43796,
	"./delete_col.svg": 24569,
	"./delete_row.svg": 72875,
	"./delete_table.svg": 27015,
	"./github.svg": 7954,
	"./hr.svg": 47449,
	"./image.svg": 25362,
	"./italic.svg": 64467,
	"./link.svg": 60239,
	"./mention.svg": 49379,
	"./ol.svg": 84206,
	"./paragraph.svg": 59631,
	"./quote.svg": 15337,
	"./redo.svg": 96343,
	"./remove.svg": 45131,
	"./strike.svg": 49417,
	"./table.svg": 89561,
	"./ul.svg": 50864,
	"./underline.svg": 66297,
	"./undo.svg": 94329
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 61007;